

import { useState, useEffect, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import { baseUrl } from "../../config/baseUrl"
import axios from "axios"
import toastify from "../../config/toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faClipboardList, faSave, faPlus, faTimes, faSearch } from "@fortawesome/free-solid-svg-icons"
import JoditEditor from "jodit-react";
import Select from "react-select"
import editorConfig from "../../utils/editorConfig"

const LANGUAGE_OPTIONS = ["English", "Hindi", "Bengali"]
const LANGUAGE_SELECT_OPTIONS = LANGUAGE_OPTIONS.map((language) => ({
    value: language,
    label: language,
}))
const getAccessTypeForAssessmentType = (assessmentType) =>
    assessmentType === "scheduled" ? "premium" : "free"

export default function AddFreeTest() {
    const [formval, setFormval] = useState({
        title: "",
        description: "",
        mockType: "test",
        category: "",
        subCategory: "",
        subject: "",
        topic: "",
        assessmentType: "daily",
        openAt: "",
        closeAt: "",
        openTime: "00:00",
        closeTime: "23:59",
        duration: 30,
        totalMarks: 30,
        positiveMark: 1,
        negativeMark: 0,
        attemptLimit: "",
        accessType: getAccessTypeForAssessmentType("daily"),
        language: ["English"],
        pdfDownload: false,
        sequence: "",
        status: "active"
    })

    const [selectedQuestions, setSelectedQuestions] = useState([])
    const [availableQuestions, setAvailableQuestions] = useState([])
    const [categories, setCategories] = useState([])
    const [subcategories, setSubcategories] = useState([])
    const [subjectsList, setSubjectsList] = useState([])
    const [loading, setLoading] = useState(false)
    const [fetchingQuestions, setFetchingQuestions] = useState(false)
    const [fetchingCategories, setFetchingCategories] = useState(false)
    const [fetchingSubcategories, setFetchingSubcategories] = useState(false)
    const [questionSearchTerm, setQuestionSearchTerm] = useState("")
    const [subjectFilter, setSubjectFilter] = useState("")
    const [subjects, setSubjects] = useState([])

    const navigate = useNavigate()

    useEffect(() => {
        fetchCategories()
        fetchSubcategories()
        fetchSubjectsList()
    }, [])

    useEffect(() => {
        // Extract unique subjects from questions
        if (availableQuestions.length > 0) {
            const uniqueSubjects = [...new Set(availableQuestions.map((q) => q.subject).filter(Boolean))]
            setSubjects(uniqueSubjects)
        }
    }, [availableQuestions])

    const buildFreeScheduleWindow = (openTime, closeTime) => {
        const baseDate = new Date()
        const [openHours = 0, openMinutes = 0] = (openTime || "00:00").split(":").map(Number)
        const [closeHours = 23, closeMinutes = 59] = (closeTime || "23:59").split(":").map(Number)

        const openDate = new Date(baseDate)
        openDate.setHours(openHours, openMinutes, 0, 0)

        const closeDate = new Date(baseDate)
        closeDate.setHours(closeHours, closeMinutes, 0, 0)

        if (closeDate <= openDate) {
            closeDate.setDate(closeDate.getDate() + 1)
        }

        return {
            openAt: openDate.toISOString(),
            closeAt: closeDate.toISOString(),
        }
    }

    const fetchCategories = async () => {
        try {
            setFetchingCategories(true)
            const response = await axios.get(`${baseUrl}/daily/mock/category`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            })
            if (response.data.status) {
                setCategories((response.data.data || []).sort((firstCategory, secondCategory) => (firstCategory.sequence || 0) - (secondCategory.sequence || 0)))
            }
        } catch (error) {
            console.error("Error fetching categories:", error)
        } finally {
            setFetchingCategories(false)
        }
    }

    const fetchSubcategories = async () => {
        try {
            setFetchingSubcategories(true)
            const response = await axios.get(`${baseUrl}/subcategory`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            })
            if (response.data.status) {
                setSubcategories(response.data.data || [])
            }
        } catch (error) {
            console.error("Error fetching subcategories:", error)
        } finally {
            setFetchingSubcategories(false)
        }
    }

    const fetchSubjectsList = async () => {
        try {
            const response = await axios.get(`${baseUrl}/subject/list`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            })
            if (response.data.status) {
                setSubjectsList(response.data.data || [])
            }
        } catch (error) {
            console.error("Error fetching subjects list:", error)
        }
    }

    const changeHandler = (e) => {
        const { name, value, type, checked } = e.target;

        let updatedValue;

        if (type === "checkbox") {
            updatedValue = checked;
        } else if (name === "pdfDownload") {
            updatedValue = value === "true";
        } else if (
            name === "negativeMark" ||
            name === "positiveMark" ||
            name === "totalMarks" ||
            name === "duration" ||
            name === "attemptLimit" ||
            name === "sequence"
        ) {
            updatedValue = value === "" ? "" : parseFloat(value);
        } else {
            updatedValue = value;
        }

        if (name === "assessmentType") {
            const nextAccessType = getAccessTypeForAssessmentType(updatedValue)

            setFormval((prevVal) => ({
                ...prevVal,
                assessmentType: updatedValue,
                accessType: nextAccessType,
            }))
            return
        }

        if (name === "accessType") {
            updatedValue = getAccessTypeForAssessmentType(formval.assessmentType)
        }

        setFormval((prevVal) => ({
            ...prevVal,
            [name]: updatedValue,
        }));
    };

    const handleLanguageChange = (selectedOptions) => {
        setFormval((prevVal) => ({
            ...prevVal,
            language: (selectedOptions || []).map((option) => option.value),
        }))
    }

    const filteredSubCat = subcategories;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formval.title) return toastify.error("Title is required");
        if (!formval.category) return toastify.error("Daily mock category is required");
        if (!formval.description) return toastify.error("Description is required");
        if (!formval.language.length) return toastify.error("Please select at least one language");

        if (formval.accessType === "free") {
            if (formval.sequence === undefined || formval.sequence === null || formval.sequence === "") {
                return toastify.error("Sequence is required");
            }
        } else {
            if (!formval.openAt) return toastify.error("Open time is required");
            if (!formval.closeAt) return toastify.error("Close time is required");
        }

        if (!formval.duration) return toastify.error("Duration is required");
        if (!formval.totalMarks) return toastify.error("Total marks is required");
        if (!formval.positiveMark) return toastify.error("Positive mark is required");
        if (formval.negativeMark === undefined || formval.negativeMark === null || formval.negativeMark === "") {
            return toastify.error("Negative mark is required");
        }
        if (!formval.attemptLimit) return toastify.error("Attempt limit is required");
        setLoading(true);

        try {
            const accessType = getAccessTypeForAssessmentType(formval.assessmentType)
            const isFree = accessType === "free";
            const schedule = isFree
                ? buildFreeScheduleWindow(formval.openTime, formval.closeTime)
                : {
                    openAt: formval.openAt ? new Date(formval.openAt).toISOString() : null,
                    closeAt: formval.closeAt ? new Date(formval.closeAt).toISOString() : null,
                };
            const payload = {
                title: formval.title,
                description: formval.description,
                mockType: formval.mockType || "test",
                category: formval.category,
                subCategory: formval.subCategory || null,
                subject: formval.subject || null,
                topic: formval.topic.trim(),
                assessmentType: formval.assessmentType,
                openAt: schedule.openAt,
                closeAt: schedule.closeAt,
                openTime: isFree ? (formval.openTime || "00:00") : null,
                closeTime: isFree ? (formval.closeTime || "23:59") : null,
                duration: Number(formval.duration),
                totalMarks: Number(formval.totalMarks),
                positiveMark: Number(formval.positiveMark),
                negativeMark: Number(formval.negativeMark),
                attemptLimit: Number(formval.attemptLimit),
                accessType,
                language: formval.language.length ? formval.language : ["English"],
                pdfDownload: formval.pdfDownload,
                sequence: isFree ? Number(formval.sequence) : null,
                status: formval.status
            };

            const response = await axios.post(`${baseUrl}/daily-mock-test`, payload, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            });

            if (response.data.status) {
                toastify.success("Test created successfully");
                navigate("/free-mock-tests");
            } else {
                toastify.error(response.data.message || "An error occurred while creating test");
            }
        } catch (error) {
            console.error("Error:", error);
            toastify.error(error.response?.data?.message || "Failed to create test");
        } finally {
            setLoading(false);
        }
    };

    const config = useMemo(() => ({
        ...editorConfig,
        height: 500,
        placeholder: "Enter test description",
    }), []);

    return (
        <>
            <style >{`
        
        .section-title {
          color: #7436A9;
          font-weight: 700;
          margin-bottom: 1rem;
          font-size: 1.1rem;
        }

        .checkbox-container {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .checkbox-container input[type="checkbox"] {
          accent-color: #7436A9;
          width: 18px;
          height: 18px;
        }

        .question-selection-container {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .search-container {
          position: relative;
        }

        .search-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #999;
        }

        .search-input {
          padding-left: 2.5rem;
          width: 100%;
        }

        .filter-container {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
          flex-wrap: wrap;
        }

        .filter-select {
          flex: 1;
          min-width: 200px;
          border-radius: 8px;
          border: 1px solid #ddd;
          padding: 0.75rem 1rem;
          background-color: white;
        }

        .available-questions {
          border: 1px solid #ddd;
          border-radius: 8px;
          max-height: 400px;
          overflow-y: auto;
        }

        .question-item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 1rem;
          border-bottom: 1px solid #eee;
          transition: all 0.3s ease;
        }

        .question-item:last-child {
          border-bottom: none;
        }

        .question-item:hover {
          background: #f8f9ff;
        }

        .question-info {
          flex: 1;
          margin-right: 1rem;
        }

        .question-text {
          font-weight: 600;
          color: #333;
          margin-bottom: 0.5rem;
          line-height: 1.4;
        }

        .question-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          font-size: 0.85rem;
          color: #666;
        }

        .question-subject {
          background: #e3f2fd;
          color: #1976d2;
          padding: 0.2rem 0.5rem;
          border-radius: 4px;
          font-weight: 600;
        }

        .question-topic {
          background: #f3e5f5;
          color: #7b1fa2;
          padding: 0.2rem 0.5rem;
          border-radius: 4px;
          font-weight: 600;
        }

        .question-id {
          background: #e8f5e8;
          color: #388e3c;
          padding: 0.2rem 0.5rem;
          border-radius: 4px;
          font-weight: 600;
        }

        .add-question-btn {
          background: #7436A9;
          color: white;
          border: none;
          border-radius: 6px;
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .add-question-btn:hover {
          background: #5a6eea;
          transform: scale(1.1);
        }

        .selected-questions {
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 1rem;
          max-height: 300px;
          overflow-y: auto;
        }

        .selected-question-item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 0.75rem;
          background: #f8f9ff;
          border-radius: 8px;
          margin-bottom: 0.75rem;
        }

        .selected-question-item:last-child {
          margin-bottom: 0;
        }

        .remove-question-btn {
          background: #ef5350;
          color: white;
          border: none;
          border-radius: 6px;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .remove-question-btn:hover {
          background: #e53935;
          transform: scale(1.1);
        }

        .empty-message {
          text-align: center;
          padding: 2rem;
          color: #666;
        }

        .loading-message {
          text-align: center;
          padding: 2rem;
          color: #7436A9;
        }

        .btn-for-add {
          background: linear-gradient(135deg, #7436A9 0%, #764ba2 100%);
          border: none;
          border-radius: 8px;
          padding: 0.75rem 2rem;
          font-weight: 600;
          transition: all 0.3s ease;
          color: white;
        }

        .btn-for-add:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
        }

        .btn-for-add:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .btn-info {
          background: #4facfe;
          border: none;
          border-radius: 8px;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .btn-info:hover {
          background: #2f86fe;
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(79, 172, 254, 0.3);
        }

        .loading-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid #f3f3f3;
          border-top: 2px solid #7436A9;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-right: 0.5rem;
        }

        .question-count-badge {
          background: #7436A9;
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
          font-size: 0.9rem;
          font-weight: 600;
          margin-left: 0.5rem;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .cards {
            padding: 1.5rem;
          }
          
          .form-section {
            padding: 1rem;
          }
          
          .question-item {
            flex-direction: column;
            gap: 1rem;
          }
          
          .question-meta {
            flex-direction: column;
            gap: 0.5rem;
          }
        }
      `}</style>

            <section className="main-sec">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="dashboard-title">
                                <h4 className="dash-head">
                                    <FontAwesomeIcon icon={faClipboardList} className="me-2" />
                                    Add Daily Mock Test
                                </h4>
                            </div>
                            <div className="custom-bredcump">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/free-mock-tests">Daily Mock Tests</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Add Daily Mock Test
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-end">
                            <Link to="/free-mock-tests" className="btn btn-info text-white">
                                <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                                Back
                            </Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cards edit-usr">
                                <form onSubmit={handleSubmit}>
                                    {/* Basic Information */}
                                    <div className="form-section">
                                        <h5 className="section-title">Basic Information</h5>
                                        <div className="row">
                                            <div className="col-lg-12 mb-4">
                                                <label htmlFor="title" className="form-label">
                                                    Title<sup className="text-danger">*</sup>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="title"
                                                    placeholder="Enter test title"
                                                    onChange={changeHandler}
                                                    value={formval?.title}
                                                />
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="mockType" className="form-label">
                                                    Mock Type<sup className="text-danger">*</sup>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="mockType"
                                                    id="mockType"
                                                    onChange={changeHandler}
                                                    value={formval?.mockType}
                                                >
                                                    <option value="test">Test</option>
                                                    <option value="day_off">Day Off</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="category" className="form-label">
                                                    Daily Mock Category<sup className="text-danger">*</sup>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="category"
                                                    id="category"
                                                    onChange={changeHandler}
                                                    value={formval?.category}
                                                >
                                                    <option value="">Select Daily Mock Category</option>
                                                    {categories.map((cat) => (
                                                        <option key={cat._id} value={cat._id}>
                                                            {cat?.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="subCategory" className="form-label">
                                                    Subcategory (Optional)
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="subCategory"
                                                    id="subCategory"
                                                    onChange={changeHandler}
                                                    value={formval?.subCategory}
                                                >
                                                    <option value="">Select Subcategory</option>
                                                    {filteredSubCat.map((subcat) => (
                                                        <option key={subcat._id} value={subcat._id}>
                                                            {subcat.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="subject" className="form-label">
                                                    Subject
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="subject"
                                                    id="subject"
                                                    onChange={changeHandler}
                                                    value={formval?.subject}
                                                >
                                                    <option value="">Select Subject</option>
                                                    {subjectsList.map((sub) => (
                                                        <option key={sub._id} value={sub._id}>
                                                            {sub.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="topic" className="form-label">
                                                    Topic
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="topic"
                                                    id="topic"
                                                    onChange={changeHandler}
                                                    value={formval?.topic}
                                                    placeholder="Enter topic"
                                                />
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="assessmentType" className="form-label">
                                                    Assessment Type<sup className="text-danger">*</sup>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="assessmentType"
                                                    id="assessmentType"
                                                    onChange={changeHandler}
                                                    value={formval?.assessmentType}
                                                >
                                                    <option value="daily">Daily</option>
                                                    <option value="scheduled">Scheduled</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="accessType" className="form-label">
                                                    Access Type<sup className="text-danger">*</sup>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="accessType"
                                                    id="accessType"
                                                    onChange={changeHandler}
                                                    value={formval?.accessType}
                                                    disabled
                                                >
                                                    <option value={formval?.accessType}>
                                                        {formval?.accessType === "premium" ? "Premium" : "Free"}
                                                    </option>
                                                </select>
                                            </div>
                                            {formval.accessType === "premium" ? (
                                                <>
                                                    <div className="col-lg-6 mb-4">
                                                        <label htmlFor="openAt" className="form-label">
                                                            Open At<sup className="text-danger">*</sup>
                                                        </label>
                                                        <input
                                                            type="datetime-local"
                                                            className="form-control"
                                                            name="openAt"
                                                            id="openAt"
                                                            onChange={changeHandler}
                                                            value={formval?.openAt}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 mb-4">
                                                        <label htmlFor="closeAt" className="form-label">
                                                            Close At<sup className="text-danger">*</sup>
                                                        </label>
                                                        <input
                                                            type="datetime-local"
                                                            className="form-control"
                                                            name="closeAt"
                                                            id="closeAt"
                                                            onChange={changeHandler}
                                                            value={formval?.closeAt}
                                                        />
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="col-lg-6 mb-4">
                                                        <label htmlFor="openTime" className="form-label">
                                                            Open Time<sup className="text-danger">*</sup>
                                                        </label>
                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            name="openTime"
                                                            id="openTime"
                                                            onChange={changeHandler}
                                                            value={formval?.openTime}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 mb-4">
                                                        <label htmlFor="closeTime" className="form-label">
                                                            Close Time<sup className="text-danger">*</sup>
                                                        </label>
                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            name="closeTime"
                                                            id="closeTime"
                                                            onChange={changeHandler}
                                                            value={formval?.closeTime}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                            <div className="col-lg-4 mb-4">
                                                <label htmlFor="attemptLimit" className="form-label">
                                                    Attempt Limit<sup className="text-danger">*</sup>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="attemptLimit"
                                                    placeholder="Enter Attempt Limit"
                                                    onChange={changeHandler}
                                                    value={formval?.attemptLimit}
                                                />
                                            </div>
                                            <div className="col-lg-4 mb-4">
                                                <label htmlFor="language" className="form-label">
                                                    Language<sup className="text-danger">*</sup>
                                                </label>
                                                <Select
                                                    inputId="language"
                                                    isMulti
                                                    name="language"
                                                    options={LANGUAGE_SELECT_OPTIONS}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    closeMenuOnSelect={false}
                                                    value={LANGUAGE_SELECT_OPTIONS.filter((option) => formval.language.includes(option.value))}
                                                    onChange={handleLanguageChange}
                                                    placeholder="Select language"
                                                    noOptionsMessage={() => "No language found"}
                                                />
                                                <small className="text-muted">Ek ya multiple language select kar sakte hain.</small>
                                            </div>
                                            <div className="col-lg-4 mb-4">
                                                <label htmlFor="pdfDownload" className="form-label">
                                                    Pdf Download<sup className="text-danger">*</sup>
                                                </label>
                                                <select className="form-control" name="pdfDownload" id="pdfDownload" onChange={changeHandler} value={String(formval?.pdfDownload)}>
                                                    <option value="false">NO</option>
                                                    <option value="true">Yes</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-12 mb-4">
                                                <label htmlFor="description" className="form-label">
                                                    Description<sup className="text-danger">*</sup>
                                                </label>
                                                <JoditEditor
                                                    value={formval?.description || ""}
                                                    config={config} // Yahan change kiya hai
                                                    tabIndex={1} // Optional: Focus maintain karne me help karta hai
                                                    onBlur={(newContent) => {
                                                        // Performance improve karne ke liye heavy logic onBlur par bhi shift kar sakte hain
                                                        // lekin agar aapko realtime chahiye toh onChange thik hai
                                                    }}
                                                    onChange={(value) => {
                                                        let content = value;
                                                        const youtubeRegex =
                                                            /https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{6,})[^\s]*/g;
                                                        content = content.replace(youtubeRegex, (match, videoId) => {
                                                            return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                                                        });

                                                        // State update karein
                                                        setFormval(prev => ({
                                                            ...prev,
                                                            description: content,
                                                        }));
                                                    }}
                                                />

                                            </div>
                                        </div>
                                    </div>

                                    {/* Test Configuration */}
                                    <div className="form-section">
                                        <h5 className="section-title">Test Configuration</h5>
                                        <div className="row">
                                            <div className="col-lg-3 mb-4">
                                                <label htmlFor="duration" className="form-label">
                                                    Duration (minutes)<sup className="text-danger">*</sup>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="duration"
                                                    placeholder="60"
                                                    onChange={changeHandler}
                                                    value={formval?.duration}
                                                />
                                            </div>
                                            <div className="col-lg-3 mb-4">
                                                <label htmlFor="totalMarks" className="form-label">
                                                    Total Marks<sup className="text-danger">*</sup>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="totalMarks"
                                                    placeholder="100"
                                                    onChange={changeHandler}
                                                    value={formval?.totalMarks}
                                                />
                                            </div>

                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="positiveMark" className="form-label">
                                                    Positive Mark<sup className="text-danger">*</sup>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="positiveMark"
                                                    placeholder="1"
                                                    onChange={changeHandler}
                                                    value={formval?.positiveMark}
                                                />
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="negativeMark" className="form-label">
                                                    Negative Mark<sup className="text-danger">*</sup>
                                                </label>
                                                <input
                                                    type="number"
                                                    name="negativeMark"
                                                    step="0.01"
                                                    min="0"
                                                    placeholder="Enter negative mark"
                                                    className="form-control"
                                                    value={formval.negativeMark}
                                                    onChange={changeHandler}
                                                />

                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="sequence" className="form-label">
                                                    Sequence{formval.accessType === "free" && <sup className="text-danger">*</sup>}
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="sequence"
                                                    placeholder={formval.accessType === "premium" ? "Sequence disabled for premium" : "Enter sequence number"}
                                                    onChange={changeHandler}
                                                    value={formval.accessType === "premium" ? "" : formval?.sequence}
                                                    disabled={formval.accessType === "premium"}
                                                />
                                            </div>
                                            <div className="col-lg-6 mb-4">
                                                <label htmlFor="status" className="form-label">
                                                    Status<sup className="text-danger">*</sup>
                                                </label>
                                                <select className="form-control" name="status" onChange={changeHandler} value={formval?.status}>
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 text-center mt-4">
                                        <button type="submit" className="btn btn-for-add text-white" disabled={loading}>
                                            {loading && <div className="loading-spinner"></div>}
                                            <FontAwesomeIcon icon={faSave} className="me-2" />
                                            {loading ? "Creating..." : "Create Test"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
